import React from 'react'
import API from "../../../../global/globalFunctions"
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import moment from 'moment';
import { Button, IconButton } from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Loader from "react-loader-spinner";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  Card,
  ModalBody,
  Modal,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { isEmpty } from "lodash";
import {
  getDivorce,
  getStates,
  postProfileInformation,
  getFormData
} from "./profileInformation.actions";
const ProfileInformation = (props) => {
  const [valueRespondentNumber, setValueRespondentNumber] = useState(0);
  const [value, setValue] = useState(0);

  const [show, setShow] = useState(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const error = () => {
    if (props.unableUpdate == false) {
      handleShow()
    }
    else {
      setShow(false)

    }
  };

  const SaveData = () => {
    props.postProfileInformation({
      divorce_id: window.localStorage.getItem("divorce_id"),
      //PETITIONER_DETAILS  
      petitionerCheck: document.getElementById("isPetitioner").value,
      petitionerFirstName: document.getElementById("pt_firstname_id").value,
      petitionerLastName: document.getElementById("pt_lastname_id").value,
      petitionerCity: document.getElementById("pt_city_id").value,
      petitionerState: document.getElementById("pt_state_id").value,
      petitionerZip: document.getElementById("pt_zip_id").value,
      petitionerTelephoneNo: document.getElementById("pt_telephone_id").value,
      petitionerEmail: document.getElementById("pt_email_id").value,
      petitionerAddress: document.getElementById("pt_address_id").value,

      //RESPONDENT_DETAILS
      spouseFirstName: document.getElementById("res_firstname_id").value,
      spouseLastName: document.getElementById("res_lastname_id").value,
      spouseCity: document.getElementById("res_city_id").value,
      spouseState: document.getElementById("res_state_id").value,
      spouseZip: document.getElementById("res_zip_id").value,
      spouseTelephoneNo: document.getElementById("res_telephone_id").value,
      spouseEmail: document.getElementById("res_email_id").value,
      spouseAddress: document.getElementById("res_address_id").value,

      courtMailingAddress: document.getElementById("court_mail_id").value,
      courtZip: document.getElementById("court_zip_id").value,
      courtStreetAddress: document.getElementById("court_street_id").value,
      courtCity: document.getElementById("court_city_id").value,
      branchName: document.getElementById("court_branch_name").value,
      county: document.getElementById("court_county_id").value,
      caseNumber: document.getElementById("caseNumber").value ? document.getElementById("caseNumber").value : "",
    });

  }

  useEffect(() => {
    props.getStates();
    props.getDivorce({
      userId: window.localStorage.getItem("user_id"),
      divorce_id: window.localStorage.getItem("divorce_id")
    });
    !isEmpty(window.localStorage.getItem("divorce_id")) &&
      props.getFormData({
        divorce_id: window.localStorage.getItem("divorce_id"),
      });

  }, []);

  return (
    <div
      style={{
        fontStyle: "normal",
        fontFamily: "sans-serif",
        backgroundColor: "white",
        textAlign: "justify",
        textJustify: "inter-word",
        padding: "30px 70px"
      }}
    >
      {
        props.isFetchingStates && props.isFetchingGetAllFormData ?
          <div style={{ marginLeft: "42%", marginTop: "18%" }}>
            <Loader
              type="Puff"
              color="#00BFFF"
              height={120}
              width={120}
            />
          </div>
          :
          <div>

            <b>
              Please provide your and your's spouse legal information this is how it appears on any of the
              filed divorce forms. Middle name is not required.
            </b>

            <Row style={{ marginTop: "5%" }} >
              <Col md={12}>
                <FormGroup>
                  <Label for="isPetitioner">Who are you?</Label>
                  <Input
                    defaultValue={props.petitionerCheck}
                    type="select"
                    name="isPetitioner"
                    id="isPetitioner"
                  >
                    <option disabled selected hidden>
                      -- select an option --
                    </option>
                    <option value="0">Petitioner</option>
                    <option value="1">Respondent</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <h5> Enter Petitioner’s Details:</h5>
            <FormGroup>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="pt_firstname_id">First Name</Label>
                    <Input
                      defaultValue={props.petitionerDetails.firstName}
                      type="text"
                      name="name"
                      id="pt_firstname_id"
                      placeholder="First Name"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="pt_lastname_id">Last Name</Label>
                    <Input
                      defaultValue={props.petitionerDetails.lastName}
                      type="text"
                      name="lastName"
                      id="pt_lastname_id"
                      placeholder="Last Name"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="pt_email_id">Email</Label>
                    <Input
                      defaultValue={props.petitionerDetails.email}
                      type="email"
                      name="email"
                      id="pt_email_id"
                      placeholder="Email"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="pt_telephone_id">Telephone No</Label>
                    <PhoneInput
                      value={props.petitionerDetails.telephone || value}
                      onChange={(e) => setValue(JSON.parse(value))}
                      id="pt_telephone_id"
                      defaultCountry='US'
                      name="telephone"
                      placeholder="Format (XXX) XXX-XXXX"
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Label for="pt_address_id">Address</Label>
                <Input
                  defaultValue={props.petitionerDetails.streetAddress}
                  type="text"
                  name="address"
                  id="pt_address_id"
                  placeholder="Address 1234 Main St"
                />
              </FormGroup>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleCity">City</Label>
                    <Input
                      defaultValue={props.petitionerDetails.city}
                      type="text"
                      name="city"
                      id="pt_city_id"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleState">State</Label>

                    {!isEmpty(props.states) && props.petitionerDetails?.state && (
                    <Input
                      defaultValue={props.petitionerDetails.state}
                      type="select"
                      name="state"
                      id="pt_state_id"
                    >
                      {props.states.map((item, i) => (
                          <option value={item.state_id}>
                            {item.state_name}
                          </option>
                      ))}
                    </Input>
                    )}
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label for="exampleZip">Zip</Label>
                    <Input
                      defaultValue={props.petitionerDetails.zip}
                      type="text"
                      name="zip"
                      id="pt_zip_id"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>



            <h4> Enter Spouse’s Details:</h4>
            <FormGroup>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="res_firstname_id">First Name</Label>
                    <Input
                      defaultValue={props.respondentDetails.firstName}
                      type="text"
                      name="name"
                      id="res_firstname_id"
                      placeholder="First Name"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="res_lastname_id">Last Name</Label>
                    <Input
                      defaultValue={props.respondentDetails.lastName}
                      type="text"
                      name="lastName"
                      id="res_lastname_id"
                      placeholder="Last Name"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="res_email_id">Email</Label>
                    <Input
                      defaultValue={props.respondentDetails.email}
                      type="email"
                      name="email"
                      id="res_email_id"
                      placeholder="Email"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleTelephone">Telephone No</Label>
                    <PhoneInput
                      value={props.respondentDetails.telephone || valueRespondentNumber}
                      onChange={(e) => setValueRespondentNumber(JSON.parse(value))}
                      id="res_telephone_id"

                      defaultCountry='US'
                      placeholder="Format (XXX) XXX-XXXX"
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Label for="res_address_id">Address</Label>
                <Input
                  defaultValue={props.respondentDetails.streetAddress}
                  type="text"
                  name="address"
                  id="res_address_id"
                  placeholder="Address 1234 Main St"
                />
              </FormGroup>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleCity">City</Label>
                    <Input
                      defaultValue={props.respondentDetails.city}
                      type="text"
                      name="city"
                      id="res_city_id"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleState">State</Label>
                    {!isEmpty(props.states) && props.respondentDetails?.state && (
                    <Input
                      defaultValue={props.respondentDetails.state}
                      type="select"
                      name="state"
                      id="res_state_id"
                      selected={props.respondentDetails.state}
                    >


                      {props.states.map((item, i) => (
                          <option value={item.state_id} >
                            {item.state_name}
                          </option>
                        ))}
                    </Input>
                    )}
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label for="exampleZip">Zip</Label>
                    <Input
                      defaultValue={props.respondentDetails.zip}
                      type="text"
                      name="zip"
                      id="res_zip_id"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>


            <h4>
              Your Local Family Court (Find your local county{" "}
              <span>
                <a
                  href="https://www.courts.ca.gov/find-my-court.htm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
              </span>
              )
            </h4>
            <FormGroup>
              <FormGroup>
                <Label for="court_street_id">Court Street Address</Label>
                <Input
                  defaultValue={props.courtDetails.courtStreetAddress}
                  type="text"
                  name="address"
                  id="court_street_id"
                  placeholder="Address 1234 Main St"
                />
              </FormGroup>

              <FormGroup>
                <Label for="court_mail_id">Mailing Address</Label>
                <Input
                  defaultValue={props.courtDetails.courtMailingAddress}
                  type="text"
                  name="mailAddress"
                  id="court_mail_id"
                  placeholder="Mailing Address"
                />
              </FormGroup>

              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleCity">City</Label>
                    <Input
                      defaultValue={props.courtDetails.city}
                      type="text"
                      name="city"
                      id="court_city_id"
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleCity">County</Label>
                    <Input
                      defaultValue={props.courtDetails.county}
                      type="text"
                      name="county"
                      id="court_county_id"
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleZip">Zip</Label>
                    <Input
                      defaultValue={props.courtDetails.zip}
                      type="text"
                      name="zip"
                      id="court_zip_id"
                    />
                  </FormGroup>
                </Col>

              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="caseNumber">Enter Case Number</Label>
                    <Input
                      defaultValue={props.courtDetails.caseNumber}
                      type="text"
                      name="caseNumber"
                      id="caseNumber"
                      placeholder="Case Number"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="court_branch_name">Branch Name</Label>
                    <Input
                      defaultValue={props.courtDetails.branchName}
                      type="text"
                      name="court_branch_name"
                      id="court_branch_name"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>




            <div style={{ display: "flex", float: "right" }}>
              <Button onClick={() => { SaveData(); error() }}>
                Save Details
              </Button>

            </div>

          </div>

      }
      {<Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%" }}>
        <ModalHeader>
          {props.unableUpdate === false ? <p> Successful </p> : <p> Unsuccessful </p>}
        </ModalHeader>
        <ModalBody>{props.unableUpdate === false ? <p> Information Updated Successfully. Continue Your Divorce. </p> : <p> Please Complete All Fields </p>}
        </ModalBody>
        <ModalFooter>
          <Row style={{ marginLeft: "3px" }}>
            <Button
              style={{ width: "48%", marginRight: "2px", color: "white", backgroundColor: "Blue" }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Row>
        </ModalFooter>
      </Modal>}


    </div>

  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    getStates: () => dispatch(getStates()),
    postProfileInformation: (data) => dispatch(postProfileInformation(data)),
    getFormData: (data) => dispatch(getFormData(data)),
    getDivorce: (data) => dispatch(getDivorce(data)),

  };
};

const mapStateToProps = (state, ownProps) => ({
  states: state.ProfileInformationReducer.states,
  petitionerCheck: state.ProfileInformationReducer.petitionerCheck,
  petitionerDetails: state.ProfileInformationReducer.petitionerDetails,
  respondentDetails: state.ProfileInformationReducer.respondentDetails,
  courtDetails: state.ProfileInformationReducer.court,
  isFetchingStates: state.ProfileInformationReducer.isFetchingStates,
  isFetchingGetAllFormData: state.ProfileInformationReducer.isFetchingGetAllFormData,
  unableUpdate: state.ProfileInformationReducer.unableUpdate,


});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileInformation);
